export default __webpack_public_path__ + "static/media/Punjabi-Kada.20ad209f.jpg";